// extracted by mini-css-extract-plugin
export default {"crateDescription":"CrateDescription_crateDescription__rgM7r","crateName":"CrateDescription_crateName__4KY6j","crateDesc":"CrateDescription_crateDesc__40bDo"};